export enum ETableCellEnum {
  Max = 'Max',
  MinMax = 'MinMax',
  CustomDays = 'CustomDays',
}

export enum ETableColumns {
  Type = 'type',
  AccountNumber = 'account_number',
  AsseCode = 'asset_code',
  Period = 'period',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
  Days = 'days',
  Max = 'max',
}
